import React from 'react';
import BulkDiscountsForm from '@dashboard/components/BulkDiscountsForm';
import CanUseFeature from '@dashboard/components/CanUseFeature';
import Features from '@dashboard/enums/features';
import useProduct from '@/dashboard/scenes/PageEdit/scenes/PageProduct/useProduct';

const ProductDiscountsForm = () => {
  const { product, updateProduct } = useProduct();

  // TODO(M14): reads legacy product scalars — repoint to prices[]/selected price before legacy fields are removed (product.currency)
  const currency = product?.currency;
  const savedDiscounts = product?.discounts || [];

  const config = {
    itemsFieldName: 'variantOptions',
    defaultQuantityCondition: 'checkoutQuantity',
    quantityConditionLabel: 'Applies to',
    quantityConditionTooltip:
      'Apply this discount based on checkout quantity selector or quantity per variant option.',
    allItemsLabel: 'Quantity selector',
    allItemsValue: 'checkoutQuantity',
    perItemLabel: 'Variant options',
    perItemValue: 'variantOptionQuantity',
    itemsLabel: 'Variant options',
    itemsPlaceholder: 'Select variant options',
    itemsValidationMessage: 'Select at least one variant option',
    itemOptions: product.variants.flatMap(variant =>
      variant.options.map(option => ({
        name: `${variant.name}: ${option.name}`,
        value: option._id,
      })),
    ),
  };

  const handleSubmit = async discounts => {
    const body = { discounts };

    const { data, error } = await updateProduct.mutateAsync(body);

    if (data) {
      return { data: data.discounts };
    }

    return { error };
  };

  return (
    <CanUseFeature feature={Features.BULK_DISCOUNTS}>
      <BulkDiscountsForm
        config={config}
        savedDiscounts={savedDiscounts}
        currency={currency}
        onSubmit={handleSubmit}
      />
    </CanUseFeature>
  );
};

export default ProductDiscountsForm;
